export const GLOBAL_DOD_AGENCY_MAPPING_RESET_STATE = 'GLOBAL_DOD_AGENCY_MAPPING_RESET_STATE';
export const GLOBAL_DOD_AGENCY_MAPPING_CURRENT_ITEM = 'GLOBAL_DOD_AGENCY_MAPPING_CURRENT_ITEM';

export const GLOBAL_DOD_AGENCY_MAPPING_REQUEST_LOADING = 'GLOBAL_DOD_AGENCY_MAPPING_REQUEST_LOADING';
export const GLOBAL_DOD_AGENCY_MAPPING_REQUEST_SUCCESS = 'GLOBAL_DOD_AGENCY_MAPPING_REQUEST_SUCCESS';
export const GLOBAL_DOD_AGENCY_MAPPING_REQUEST_FAILED = 'GLOBAL_DOD_AGENCY_MAPPING_REQUEST_FAILED';

export const GLOBAL_DOD_AGENCY_MAPPING_CURRENT_ACTION = 'GLOBAL_DOD_AGENCY_MAPPING_CURRENT_ACTION';
export const GLOBAL_DOD_AGENCY_MAPPING_RESET_ACTION = 'GLOBAL_DOD_AGENCY_MAPPING_RESET_ACTION';